// extracted by mini-css-extract-plugin
export default {"row":"Row_row__F-LaL","withBorder":"Row_withBorder__thFoJ"};